













































































import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import { ciCart } from '~/icons/source/regular/cart'
import { ciCheck } from '~/icons/source/solid/check'
import { Classified } from '~/models/classified/types'
import { ciTimes } from '~/icons/source/solid/times'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useUserAgent } from '~/compositions/user-agent'
import { ClassifiedMarketplaceInfo } from '~/models/classified/view'

export default defineComponent({
  components: { CImg },
  props: {
    marketplace: {
      type: Object as PropType<ClassifiedMarketplaceInfo>,
      required: true
    },
    classified: {
      type: Object as PropType<Classified>,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    imageUrl: {
      type: String,
      default: ''
    }
  },
  setup(_props, { emit }) {
    const { isMobile } = useUserAgent()

    function onContinuePurchasesButtonClick() {
      emit('close')
    }

    function onClosePopupButtonClick() {
      emit('close')
    }

    return {
      ciCart,
      ciCheck,
      ciTimes,
      isMobile,
      onContinuePurchasesButtonClick,
      onClosePopupButtonClick
    }
  },
  i18n: defineComponentTranslations({
    complete_purchase: {
      en: 'Complete purchase',
      el: 'Ολοκλήρωση αγοράς'
    },
    continue_purchases: {
      en: 'Continue purchases',
      el: 'Συνέχεια αγορών'
    }
  })
})
